import { render, staticRenderFns } from "./MentionPopup.vue?vue&type=template&id=274f7d32&scoped=true"
import script from "./MentionPopup.vue?vue&type=script&lang=js"
export * from "./MentionPopup.vue?vue&type=script&lang=js"
import style0 from "./MentionPopup.vue?vue&type=style&index=0&id=274f7d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274f7d32",
  null
  
)

export default component.exports